import React from "react";
import classNames from "classnames";

import { ContentLoaderInterface } from "shared/components/ContentLoader/ContentLoader.interface";
import SkeletonLoader from "shared/components/SkeletonLoader";

import styles from "./ContentLoader.module.scss";

export const ContentLoader: React.FC<ContentLoaderInterface> = ({
  amount = 1,
  height = 250,
  className,
}) => (
  <div className={classNames(styles.loader, className)}>
    {Array.from(Array(amount), (_, i) => (
      <SkeletonLoader key={i} height={height} />
    ))}
  </div>
);

export default ContentLoader;
